/** @format */

import { ReactComponent as Cap } from "bootstrap-icons/icons/mortarboard.svg";
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useLocale } from "../../i18n/hooks";
// import { ReactComponent as ChevronRight } from 'bootstrap-icons/icons/chevron-right.svg'
import { ReactComponent as LinkIcon } from "bootstrap-icons/icons/link-45deg.svg";
//import EnglishResourceFilterBanner from "../../assets/images/resource-filter-banner-english.png";
//import WelshResourceFilterBanner from "../../assets/images/resource-filter-banner-welsh.png";
// import SubjectIcon from './icons/chemistry'
// import { useAppDispatch } from '../../app/hooks'
// import _subjects from '../../json/subjects2.json'
import "./SubjectsIndex.scss";
import SubjectIcon from "./SubjectIcon";
import { CSSTransition } from "react-transition-group";
import { Subject, useGetSubjectsQuery } from "../../app/services/subjectApi";
import { Alert } from "react-bootstrap";
import { selectBrand, Text } from "../resources/resourcesSlice";
import { skipToken } from "@reduxjs/toolkit/query";
import { useAppSelector } from "../../app/hooks";
import { useGetUserQuery } from "../../app/services/userApi";

const SubjectButton: React.FC<{
  title: string;
  subject?: Subject;
}> = ({ title, subject }) => {
  return (
    <div key={title} className="subject col mb-3">
      <Link
        to={
          subject
            ? encodeURIComponent(title).replace(/\//g, "%2F")
            : "user/dashboard"
        }
        className="btn btn-dark w-100 text-start d-flex align-items-center p-0 border-0"
      >
        <div
          className="icon d-block bg-primary p-2"
          style={{ transform: "translateX(-1px)" }}
        >
          {subject ? (
            <SubjectIcon className="p-1" subject={subject} />
          ) : (
            <Cap />
          )}
        </div>

        <div className="title text-white my-2 ps-4 pe-2 flex-fill">
          <label>{title}</label>
        </div>

        <div className="align-self-stretch">
          <div
            className="d-flex flex-column rounded-end overflow-hidden text-dark h-100"
            style={{ minWidth: "2.2em" }}
          >
            <span className="link-icon bg-info h-50 w-100 d-flex align-items-center">
              <LinkIcon className="h-75 w-auto mx-auto" />
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

const SubjectsIndex: React.FC = () => {
  const { data, isLoading } = useGetSubjectsQuery();
  const { t: _ } = useTranslation();
  const letters: Text = {
    en: "a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z",
    cy: "a,b,c,ch,d,dd,e,f,ff,g,ng,h,i,j,l,ll,m,n,o,p,ph,r,rh,s,t,th,u,w,y",
  };
  const nodeRef = React.useRef(null);
  const locale = useLocale();
  const [showAlert, setShowAlert] = useState(true);
  const [showAlertButton, setShowAlertButton] = useState(false);
  const brand = useSelector(selectBrand());
  const [filteredSubjects, setFilteredSubjects] = useState<Subject[]>([]);

  const isAuthenticated =
    useAppSelector((state) => state.auth.userToken?.token) || false;
  const { data: user, isLoading: isUserLoading } = useGetUserQuery(
    !!isAuthenticated ? undefined : skipToken,
  );
  const isTeacher =
    !isUserLoading && user !== undefined && user.role === "teacher";

  useEffect(() => {
    // document.title = `${_('Subjects')} - ${_('Educational Resources')} - ${_('WJEC')}`
    document.title = `${_("Educational Resources")} - ${_("WJEC")}`;
  }, [locale, _]);

  useEffect(() => {
    /* const subjectFilter: string[] = [
      "art",
      "biology",
      "business",
      "chemistry",
      "computer-sci",
      "core-cymraeg",
      "drama",
      "engLitLang",
      "engLit",
      "engLang",
      "food",
      "french",
      "geography",
      "german",
      "history",
      "mathematics-and-numeracy",
      "maths",
      "media",
      "music",
      "physics",
      "religious-studies",
      "spanish",
      "welsh-language-and-literature",
      "welsh-language",
      "welsh-literature",
      "welsh-second",
    ]; */

    if (data) {
      setFilteredSubjects(
        [...data.subjects].filter((s: Subject) => s?.indexed),
      );
    }
  }, [data]);

  const dismissAlert = () => setShowAlert(false);

  return (
    <div className="SubjectsIndex container px-0 mt-4">
      {showAlertButton && (
        <div className="text-end">
          <button
            className="btn btn-link mb-2"
            onClick={() => setShowAlert(true)}
          >
            {_("Can't find what you're looking for?")}
          </button>
        </div>
      )}
      <CSSTransition
        in={showAlert}
        timeout={200}
        classNames="fade"
        unmountOnExit
        onEnter={() => setShowAlertButton(false)}
        onExited={() => setShowAlertButton(true)}
        nodeRef={nodeRef}
      >
        <div
          ref={nodeRef}
          className={`alert alert-${
            brand === "eduqas" ? "warning" : "info"
          } alert-dismissible fade show mb-4`}
          role="alert"
        >
          <Trans
            i18nKey="headerMsg"
            // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
            components={{ p: <p />, a: <a /> }}
            values={{
              emailLink: `${
                locale === "en" ? "resources@wjec.co.uk" : "adnoddau@cbac.co.uk"
              }`,
            }}
          />
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => dismissAlert()}
          ></button>
        </div>
      </CSSTransition>

      {/* <div className="resource-filter-banner mb-5">
        {
          locale === 'en' ? (
            <img src={EnglishResourceFilterBanner} alt="English Resource Filter banner" className="w-100"/>
          ) : (
            <img src={WelshResourceFilterBanner} alt="Welsh Resource Filter banner" className="w-100"/>
          )
        }
      </div> */}

      {isLoading || isUserLoading ? (
        <Alert variant="info">{_("Loading")}...</Alert>
      ) : (
        <>
          {isTeacher && (
            <>
              <h1 className="display-4 fw-bold mb-4">{_("My Resources")}</h1>
              <section className="letter row row-cols-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 pb-3">
                <SubjectButton title={_("My Resources")} />
              </section>
            </>
          )}

          <h1 className="display-4 fw-bold mb-4">
            {_("Subjects")}{" "}
            <sup className="text-muted">
              ({filteredSubjects.length ?? "..."})
            </sup>
          </h1>
          {letters[locale].split(",").map((letter) => {
            const filtered = filteredSubjects
              ? filteredSubjects.filter(
                  (subject: Subject) =>
                    subject.title[locale].toLowerCase().startsWith(letter) &&
                    (letter.length > 1 || locale === "en"
                      ? true
                      : !subject.title[locale]
                          .toLowerCase()
                          .startsWith(letter + letter) &&
                        !subject.title[locale].match(/^(?:ch|ng|ph|rh|th)/i)),
                )
              : [];
            if (filtered.length === 0) return null;
            return (
              <div key={letter}>
                <h3 className="text-dark border-bottom display-6 fw-normal mb-3">
                  {letter.toUpperCase()}
                </h3>
                <section className="letter row row-cols-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 pb-3">
                  {filtered.map((subject) => (
                    <SubjectButton
                      title={subject.title[locale]}
                      subject={subject}
                    />
                  ))}
                </section>
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

// const SubjectsIndex2: React.FC = () => {
//   const subjects = useSelector(selectSubjects())
//   const { t: _ } = useTranslation()
//   const letters: Text = {
//     en: 'a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z',
//     cy: 'a,b,c,ch,d,dd,e,f,ff,g,ng,h,i,j,l,ll,m,n,o,p,ph,r,rh,s,t,th,u,w,y'
//   }
//   const locale = useLocale()
//   const dispatch = useAppDispatch()

//   useEffect(() => {
//     dispatch(setSubjects(_subjects as Subject[]))
//   }, [dispatch])

//   return <div className="HomePage">
//     <h1>{_('Subjects')}</h1>

//     {letters[locale].split(',').map((letter) => {
//       const filtered = subjects.filter((subject) => (
//         subject.resourceCount > 0
//         &&
//         subject.title[locale].toLowerCase().startsWith(letter)
//         &&
//         (
//           (letter.length > 1 || locale === 'en')
//             ? true
//             : (
//               !subject.title[locale].toLowerCase().startsWith(letter + letter)
//               &&
//               !subject.title[locale].match(/^(?:ch|ng|ph|rh|th)/i)
//             )
//         )
//       ))
//       if (filtered.length === 0) return null
//       return <div key={letter}>
//         <h3 className="text-primary border-bottom">{letter.toUpperCase()}</h3>
//         <div className="row row-cols-sm-1 row-cols-md-2 row-cols-xl-3">
//           {filtered.map((subject) => (
//             <div key={subject.id} className="col mb-3">
//               <Link to={encodeURIComponent(subject.title[locale])} className="btn btn-lg btn-secondary w-100 text-start d-flex align-items-center">
//                 {subject.title[locale]}
//                 <span className="badge bg-primary rounded-pill ms-auto me-2">{subject.resourceCount}</span>
//                 <ChevronRight />
//               </Link>
//             </div>
//           ))}
//         </div>
//       </div>
//     })}
//   </div>
// }

export default SubjectsIndex;
